import { FC } from "react";

interface CardVideoProps {
  posterSrc: string;
  videoSrc: string;
  ratio: string;
}

const CardVideo: FC<CardVideoProps> = ({ posterSrc, videoSrc, ratio }) => {
  return (
    <div className={`w-full h-CardGallery md:h-CardGalleryDesktop ${ratio === "3:4" ? "aspect-3-4" : "aspect-4-3"}`}>
      <video className="object-cover w-full h-full rounded-lg" poster={posterSrc} autoPlay muted loop playsInline>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
export default CardVideo;
